module.exports = __webpack_public_path__ + "static/media/3.9ab510ec.png";